<wr-base-dialog status="primary"
                header="Protokoll veröffentlichen"
                submitText="Veröffentlichen"
                cancelText="Abbrechen">
  <div class="audience-container" [nbSpinner]="loading()">
    @if (audience(); as tenants) {
      @if (tenants.length > 0) {
        <p>Das Protokoll wird für folgende externe Kunden sichtbar:</p>
        <ul class="audience-list">
          @for (name of tenants; track name) {
            <li>{{ name }}</li>
          }
        </ul>
      } @else {
        <wr-banner status="warning"
                   [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                   message="Dieses Protokoll ist keinem Gebäude zugeordnet und wird daher für keine externen Nutzer sichtbar sein.">
        </wr-banner>
      }
    } @else if (!loading()) {
      <wr-banner status="warning"
                 [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                 message="Die Empfängerliste konnte nicht geladen werden. Beim Veröffentlichen wird das Protokoll trotzdem für alle berechtigten externen Kunden sichtbar.">
      </wr-banner>
    }
  </div>
</wr-base-dialog>
